
define('app/dashboard/leagues/instances/views/fantTeamSettingsView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'known/models/productTypeModel'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		FantasyTeamModel,
		ProductTypeModel){

	//Views
	var EditTeamFooterView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.showEditForm();
			
			this.listenTo(this.event, 'default', this.showEditForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showEditForm);
			this.listenTo(this.event, 'success', this.showEditForm);
			
			_.bindAll(this, 'submitEditForm');
			
			$(this.el).find(".editTmFormSubmit").on('click', this.submitEditForm);
		},
		
		hideAll: function () {
			this.$(".editTmFormSubmit").hide();
			this.$(".editTmFormCancel").hide();
		},
		
		submitEditForm: function () {
			this.event.trigger("save");
		},
		
		showEditForm: function () {
			this.hideAll();
			this.$(".editTmFormSubmit").show();
			this.$(".editTmFormCancel").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var EditTeamContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.fantTeam = options.fantTeam;
			this.prodType = options.prodType;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.submitEditTeam);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.editTeamForm);
			this.listenTo(this.event, 'success', this.editTeamForm);
			
			this.listenTo(this.fantTeam, 'numTeamChange', this.populateDraftPosDropdown);
			this.listenTo(this.lgInstance, 'change:draftStatus', this.handleDraftStatus);
			this.listenTo(this.lgInstance, 'change:draftType', this.updateBudgetDisplay);
						
			//Error handling
			this.listenTo(this.event, 'error:teamname', this.errorTeamName);
			this.listenTo(this.event, 'error:draftposition', this.errorDraftPos);
			this.listenTo(this.event, 'error:leagueuserid', this.errorOwner);
			this.listenTo(this.event, 'error:auctionbudget', this.errorBudget);
		},
		
		render: function() {
			this.populateDraftPosDropdown();
			this.populateOwnerDropdown();
			this.dispCommishOptions();
			this.handleDraftStatus();
			this.updateBudgetDisplay();
			
			//Initialize fields
			this.$(".editTmNameInput").val(this.fantTeam.get("teamName"));
			this.$(".editTmBudgetInput").val(this.fantTeam.get("auctionBudget"));
			
			return this;
		},
		
		submitEditTeam: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				var budget = this.fantTeam.get("auctionBudget"); 
				if(this.lgInstance.get('draftType') == 'AUCTION'){
					budget = this.$(".editTmBudgetInput").val();
					
					if(!budget || budget == ""){
						this.event.trigger("error");
						this.event.trigger("error:auctionbudget", "NULL");
						return;
					} else if(budget == "0" || budget == "00" || budget == "000"){
						this.event.trigger("error");
						this.event.trigger("error:auctionbudget", "LENGTH");
						return;
					}
				}
				
				this.submittedData.isSubmitted = true;
				this.fantTeam.save({
					leagueUserId: this.$(".editTmOwnerSelInput").val(),
					teamName: this.$(".editTmNameInput").val(),
					draftPosition: this.$(".editTmDraftPosSelInput").val(),
					auctionBudget: budget 
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$(".editTmDraftPosSelGrp").removeClass("error");
			this.$(".editTmDraftPosSelErrMsg").hide();
			
			this.$(".editTmOwnerSelGrp").removeClass("error");
			this.$(".editTmOwnerSelErrMsg").hide();
			
			this.$(".editTmNameGrp").removeClass("error");
			this.$(".editTmNameInput").removeClass("error");
			this.$(".editTmNameErrMsg").hide();
			
			this.$(".editTmBudgetGrp").removeClass("error");
			this.$(".editTmBudgetInput").removeClass("error");
			this.$(".editTmBudgetErrMsg").hide();
		},
		
		editTeamForm: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		dispCommishOptions: function () {
			if(this.lgInstance.isCommissioner(this.userModel.get('userName'))){
				this.$(".editTmDraftPosSelGrp").show();
				this.$(".editTmOwnerSelGrp").show();
			} else {
				this.$(".editTmDraftPosSelGrp").hide();
				this.$(".editTmOwnerSelGrp").hide();
			}
		},
		
		handleDraftStatus: function () {
			if(this.lgInstance.get("draftStatus") == "COMPLETED"){
				this.$(".editTmDraftPosSelGrp").hide();
			}
		},
		
		updateBudgetDisplay: function() {
			if(this.lgInstance.get('draftType') == 'AUCTION'){
				$(this.el).find('.editTmBudgetGrp').show();
			} else {
				$(this.el).find('.editTmBudgetGrp').hide();
			}
		},
		
		populateDraftPosDropdown: function () {
			var numTeams = this.lgInstance.numTeams();		
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.$(".editTmDraftPosSelInput").empty();
			
			for(var i=1; i <= numTeams; i++) {
				var selected = "";
				
				if(this.fantTeam.get("draftPosition") == i){
					selected = "\" selected=\"true";
				}
				
				this.$(".editTmDraftPosSelInput").append(optionStart 
						+ i
						+ selected
						+ optionMiddle
						+ i						
						+ optionEnd);
			}
		},
		
		populateOwnerDropdown: function () {
			var owners = this.lgInstance.get("leagueUsers");
			var sortedOwners = owners.sortBy(function(leagueUser){ 
				return leagueUser.prettyDispName(); 
			});
			
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.$(".editTmOwnerSelInput").empty();
			
			_.each(sortedOwners, function(lgOwner){
				var selected = "";
				
				if(this.fantTeam.get("leagueUserId") == lgOwner.get("id")){
					selected = "\" selected=\"true";
				}
				
				this.$(".editTmOwnerSelInput").append(optionStart 
						+ lgOwner.get("id")
						+ selected
						+ optionMiddle
						+ lgOwner.prettyDispName()						
						+ optionEnd);
			}, this);
		},
		
		errorDraftPos : function (errorCode) {
			this.$(".editTmDraftPosSelGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editTmDraftPosSelErrMsg").html("Draft position is empty");
					this.$(".editTmDraftPosSelErrMsg").show();
					break;
				default : 
					this.$(".editTmDraftPosSelErrMsg").html("Draft position is invalid");
					this.$(".editTmDraftPosSelErrMsg").show();
			}
		},
		
		errorOwner : function (errorCode) {
			this.$(".editTmOwnerSelGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editTmOwnerSelErrMsg").html("Owner is empty");
					this.$(".editTmOwnerSelErrMsg").show();
					break;
				default : 
					this.$(".editTmOwnerSelErrMsg").html("Owner is invalid");
					this.$(".editTmOwnerSelErrMsg").show();
			}
		},
		
		errorTeamName : function (errorCode) {
			this.$(".editTmNameGrp").addClass("error");
			this.$(".editTmNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editTmNameErrMsg").html("Team name is empty");
					this.$(".editTmNameErrMsg").show();
					break;
				case "LENGTH":
					this.$(".editTmNameErrMsg").html("Team name must be between 2 and 20 characters long");
					this.$(".editTmNameErrMsg").show();
					break;
				case "ALPHANUMSPACE":
					this.$(".editTmNameErrMsg").html("Team name may only contain alpha numeric characters and spaces");
					this.$(".editTmNameErrMsg").show();
					break;
				default : 
					this.$(".editTmNameErrMsg").html("Team name is invalid");
					this.$(".editTmNameErrMsg").show();
			}
		},
		
		errorBudget: function(errorCode) {
			this.$(".editTmBudgetGrp").addClass("error");
			this.$(".editTmBudgetInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$(".editTmBudgetErrMsg").html("Budget is empty");
					this.$(".editTmBudgetErrMsg").show();
					break;
				case "LENGTH":
					this.$(".editTmBudgetErrMsg").html("Budget must be between 1 and 999");
					this.$(".editTmBudgetErrMsg").show();
					break;
				case "NUMERIC":
					this.$(".editTmBudgetErrMsg").html("Budget may only contain numeric characters");
					this.$(".editTmBudgetErrMsg").show();
					break;
				default : 
					this.$(".editTmBudgetErrMsg").html("Budget is invalid");
					this.$(".editTmBudgetErrMsg").show();
			}
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var EditTeamMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".editTmBodyMessageError").hide();
			this.$(".editTmBodyMessageProcessing").hide();
			this.$(".editTmBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editTmBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editTmBodyMessageSuccess").show();
			this.$(".editTmBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".editTmBodyMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var EditTeamView = Backbone.View.extend({
		initialize: function(options) {		
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.fantTeam = options.fantTeam;
			this.prodType = options.prodType;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			_.bindAll(this, 'formSubmit');
			
			this.message = new EditTeamMessageView({el: this.$(".editTmBodyMessage"), event: this.event});
			this.content = new EditTeamContentView({
					el: this.$(".editTmBodyContent"),
					event: this.event,
					submittedData : this.submittedData,
					userModel: this.userModel, 
					lgInstance: this.lgInstance,
					fantTeam: this.fantTeam,
					prodType: this.prodType});
			this.footer = new EditTeamFooterView({el: this.$(".editTmFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
			
			this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var editTmOpenBtn = this.$(".editTmOpen");
			var editTmCloseBtn = this.$(".editTmFormCancel");
			
			editTmOpenBtn.on('click', {}, this.showView);
			editTmCloseBtn.on('click', {}, this.hideView);
			
			this.$(".editTmBodyContent").submit(this.formSubmit);
		},
		
		render: function () {
			this.content.render();
			
			this.event.trigger("default");
			this.updateVisuals();
			return this;
		},
		
		updateVisuals: function() {
			//Determine whether to show the Edit Team form button
			if((this.lgInstance.isAssistant(this.userModel.get('userName'))
						|| this.lgInstance.getLeagueUser(this.userModel.get('userName')).get('id') == this.fantTeam.get('leagueUserId')) 
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				this.$(".editTmOpen").show();
			} else {
				this.$(".editTmOpen").hide();
			}
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$(".editTmOpen").show();
			this.$(".editTmBodyContent").slideUp();
		},
		
		showView: function() {
			this.$(".editTmOpen").hide();
			this.$(".editTmBodyContent").slideDown();
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		success: function () {			
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$(".editTmOpen").show();
			this.$(".editTmBodyContent").hide();
		},
		
		formSubmit: function(e) {
			e.preventDefault();
			return false;
		},
	    
	    destroyView: function() {
	    	this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return EditTeamView;  
});